export const setMetaTags = (title = null, description = null, image = null) => {
    if (title) {
        document.querySelector('meta[name="title"]').setAttribute("content", title);
        document.querySelector('meta[property="og:title"]').setAttribute("content", title);
        document.querySelector('meta[property="twitter:title"]').setAttribute("content", title);
        document.title = "My new Document Title!!";
    }
    if (description) {
        document.querySelector('meta[name="description"]').setAttribute("content", description);
        document.querySelector('meta[property="og:description"]').setAttribute("content", description);
        document.querySelector('meta[property="twitter:description"]').setAttribute("content", description);
    }
    if (image) {
        document.querySelector('meta[name="image"]').setAttribute("content", image);
        document.querySelector('meta[property="og:image"]').setAttribute("content", image);
        document.querySelector('meta[property="twitter:image"]').setAttribute("content", image);
    }
}
